import { Close } from "@mui/icons-material";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";

import { chooseInputComponent } from "../../common/utils/components";
import FormInput from "../shared/FormInput";
import Dropdown from "../shared/Dropdown";
import { getTranslation } from "../../utils/translate";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  minWidth: "250px",
  maxWidth: "1000px",
  maxHeight: "90vh",
  overflow: "auto",
  bgcolor: "white",
  p: 4,
  border: "none",
};

const BeefCutsForm = ({
  beefCuts,
  selectedBeefCuts,
  setSelectedBeefCuts,
  handleSubmit,
  onClose,
  isLoading,
  language,
  posterTitle,
  onPosterTitleChange,
  posterHeaderImage,
  onPosterHeaderImageChange,
}) => {
  const showPosterFields =
    typeof onPosterTitleChange === "function" &&
    typeof onPosterHeaderImageChange === "function";
  const handleInputChange = (field, value) => {
    // Limit to maximum 28 beef cuts
    if (value.length <= 28) {
      setSelectedBeefCuts(value);
    }
  };

  return (
    <Box sx={style}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography sx={{ fontWeight: "600" }} variant="h6" component="h2">
          Choose up to 28 Beef Cuts
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: "#090909",
            padding: "4px",
          }}
        >
          <Close fontSize="medium" />
        </IconButton>
      </Box>

      {showPosterFields ? (
        <Stack spacing={2} sx={{ mb: 2 }}>
          <FormInput
            field="posterTitle"
            label="Poster title"
            description="Printed on the PDF header; used as the download file name."
            value={posterTitle ?? ""}
            handleInputChange={(_field, value) => onPosterTitleChange(value)}
            type="text"
          />
          <Box key={posterHeaderImage || "no-asset"}>
            {chooseInputComponent(
              {
                name: "posterHeaderImage",
                label: "Poster header image (center)",
                description:
                  "Logo in the center of the header band. Upload to override the retailer logo.",
                type: "image",
                value: posterHeaderImage,
                handleInputChange: (_field, assetId) =>
                  onPosterHeaderImageChange(assetId),
              },
              language.code,
            )}
          </Box>
        </Stack>
      ) : null}

      <Dropdown
        field="beefCuts"
        value={selectedBeefCuts}
        handleInputChange={handleInputChange}
        isMultiple={true}
        description="Select Beef Cuts"
        disabled={selectedBeefCuts.length >= 28}
        showClearAll={true}
        isLoading={isLoading}
        options={
          beefCuts
            ? beefCuts
                .map((product) => {
                  const t = getTranslation(
                    product,
                    { key: "languages_id", code: language.code },
                    "translations",
                  );
                  return {
                    id: product?.id,
                    label: t?.name ?? product?.translations?.[0]?.name ?? "",
                  };
                })
                .sort((a, b) => a.label.localeCompare(b.label))
            : []
        }
      />

      <Button
        className="form-button"
        sx={{ my: 2 }}
        size="large"
        variant="contained"
        onClick={handleSubmit}
      >
        Generate Poster
      </Button>
    </Box>
  );
};

export default BeefCutsForm;
